// Function to enforce character limit with a specific limit
function enforceCharacterLimit(textarea, maxLength) {
    textarea.addEventListener('input', function() {
        if (this.value.length > maxLength) {
            this.value = this.value.slice(0, maxLength);
        }
    });
}

// Get all textareas
const textareas = document.querySelectorAll('textarea');

// Loop through textareas and apply the appropriate limit based on name
textareas.forEach(textarea => {
    if (textarea.name.includes('Quote')) {
        enforceCharacterLimit(textarea, 70);  // Set limit to 70 for 'Quote'
    } else if (textarea.name.includes('message')) {
        enforceCharacterLimit(textarea, 100); // Set limit to 100 for 'Message'
    }
});